import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'

import { LoyaltyDashboardDetailsDto } from '@model/IntroducingBrokerLoyalty'

import { useIBLoyalty } from './Dashboard/hooks/useIBLoyalty'

type ContextType = {
  ibLoyaltyData?: LoyaltyDashboardDetailsDto | null
  isLoyaltyDataLoading?: boolean
  refreshIbLoyaltyData?: (skipLoadingFlag?: boolean) => void
}

export const IntroducingBroker: React.FC = () => {
  const {
    data: ibLoyaltyData,
    isLoading: isLoyaltyDataLoading,
    forceRefresh: refreshIbLoyaltyData,
  } = useIBLoyalty()

  return (
    <Outlet
      context={{ ibLoyaltyData, isLoyaltyDataLoading, refreshIbLoyaltyData } satisfies ContextType}
    />
  )
}

export const useLoyaltyData = (): ContextType => {
  return useOutletContext<ContextType>()
}
